import { Button } from "antd";
import PropTypes from "prop-types";

const ALIGNMENTS = ["left", "center", "right"];

const TYPES = [
  "default",
  "primary",
  "secondary",
  "primary--light",
  "secondary--light",
  "primary--link",
  "secondary--link",
  "primary--outlined",
  "success",
  "success--link",
  "success--light",
  "black",
  "gray",
  "gray--outlined",
  "warning",
  "warning--link",
  "warning--light",
  "danger",
  "danger--link",
  "danger--outlined",
  "danger--light",
];

const Component = ({ type, alignment, children, size, ...rest }) => (
  <div className={`button__wrapper ${alignment}`}>
    <Button className={[type, size]} size={size} {...rest}>
      {children}
    </Button>
  </div>
);

Component.propTypes = {
  alignment: PropTypes.oneOf(ALIGNMENTS),
  type: PropTypes.oneOf(TYPES),
};

Component.defaultProps = {
  alignment: "left",
  type: "default",
};

export default Component;
